(function () {
    'use strict';

    class FeedItemSessionViewerController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, AppStates, UsersManager, moment) {
            super($scope, $injector);
            this.__objectType = 'FeedItemSessionViewerController';

            this.moment = moment;

            this.AppStates = AppStates;
            this.UsersManager = UsersManager;
        }

        $onInit() {
            this.user = this.UsersManager.getCurrUser();

            this.isCanceled = this.activity.action_type === 'meeting_canceled';
            this.isScheduled = this.activity.action_type === 'meeting_scheduled';
            this.isRescheduled = this.activity.action_type === 'meeting_updated';

            this.performedByCurrentUser = this.activity.performing_user_id === this.user._id;
            this.calendarItemTitle = this.activity.calendar_item.title.replace("'", "\\'");
        }

        getSessionDate() {
            return this.activity.calendar_item.date_start || this.activity.calendar_item.date_time_start;
        }

        shouldShowViewCalendar() {
            return this.activity.calendar_item.owner_id === this.user._id;
        }
    }

    Components.FeedItemSessionViewer = {
        bindings: {
            activity: '<'
        },
        controller: FeedItemSessionViewerController,
        name: 'hbFeedItemSessionViewer',
        templateUrl: 'angular/app/modules/core/features/feed/viewer/feed_item_session_viewer_template.html',
    };

}());